package kz.dentalcrm.app.screens.appointments

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawingPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.material3.PrimaryScrollableTabRow
import androidx.compose.material3.Tab
import androidx.compose.material3.adaptive.currentWindowAdaptiveInfo
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.LifecycleEventObserver
import androidx.lifecycle.LifecycleOwner
import androidx.compose.ui.platform.LocalLifecycleOwner
import androidx.window.core.layout.WindowSizeClass.Companion.WIDTH_DP_LARGE_LOWER_BOUND
import androidx.window.core.layout.WindowSizeClass.Companion.WIDTH_DP_MEDIUM_LOWER_BOUND
import com.kizitonwose.calendar.compose.WeekCalendar
import com.kizitonwose.calendar.compose.weekcalendar.rememberWeekCalendarState
import com.kizitonwose.calendar.core.minusDays
import com.kizitonwose.calendar.core.now
import com.kizitonwose.calendar.core.plusDays
import compose.icons.FeatherIcons
import compose.icons.feathericons.CheckCircle
import compose.icons.feathericons.Circle
import compose.icons.feathericons.Edit
import compose.icons.feathericons.Phone
import compose.icons.feathericons.Plus
import compose.icons.feathericons.Trash
import compose.icons.feathericons.XCircle
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.appointment_time
import dentalcrm.composeapp.generated.resources.appointments_formatter
import dentalcrm.composeapp.generated.resources.comment_append
import dentalcrm.composeapp.generated.resources.connect
import dentalcrm.composeapp.generated.resources.delete
import dentalcrm.composeapp.generated.resources.details
import dentalcrm.composeapp.generated.resources.doctor_formatter
import dentalcrm.composeapp.generated.resources.error_no_records
import dentalcrm.composeapp.generated.resources.tab_all
import dentalcrm.composeapp.generated.resources.month_eight
import dentalcrm.composeapp.generated.resources.month_eleven
import dentalcrm.composeapp.generated.resources.month_five
import dentalcrm.composeapp.generated.resources.month_four
import dentalcrm.composeapp.generated.resources.month_nine
import dentalcrm.composeapp.generated.resources.month_one
import dentalcrm.composeapp.generated.resources.month_seven
import dentalcrm.composeapp.generated.resources.month_six
import dentalcrm.composeapp.generated.resources.month_ten
import dentalcrm.composeapp.generated.resources.month_three
import dentalcrm.composeapp.generated.resources.month_twelve
import dentalcrm.composeapp.generated.resources.month_two
import dentalcrm.composeapp.generated.resources.not_visited_short
import dentalcrm.composeapp.generated.resources.patient_formatter
import dentalcrm.composeapp.generated.resources.pending_short
import dentalcrm.composeapp.generated.resources.today
import dentalcrm.composeapp.generated.resources.visited_short
import dentalcrm.composeapp.generated.resources.week_day_five_short
import dentalcrm.composeapp.generated.resources.week_day_four_short
import dentalcrm.composeapp.generated.resources.week_day_one_short
import dentalcrm.composeapp.generated.resources.week_day_seven_short
import dentalcrm.composeapp.generated.resources.week_day_six_short
import dentalcrm.composeapp.generated.resources.week_day_three_short
import dentalcrm.composeapp.generated.resources.week_day_two_short
import io.github.alexzhirkevich.compottie.LottieCompositionSpec
import io.github.alexzhirkevich.compottie.rememberLottieComposition
import io.github.alexzhirkevich.compottie.rememberLottiePainter
import kotlinx.collections.immutable.PersistentList
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.ui.components.refresh.PullToRefresh
import kz.dentalcrm.app.core.ui.components.refresh.rememberPullToRefreshState
import kz.dentalcrm.app.theme.shimmer.ShimmerBounds
import kz.dentalcrm.app.theme.shimmer.rememberShimmer
import kz.dentalcrm.app.theme.shimmer.shimmer as shimmerModifier
import kotlinx.datetime.LocalDate
import kotlinx.datetime.format.Padding
import kotlinx.collections.immutable.PersistentMap
import kz.dentalcrm.app.core.ui.ScreenState
import kz.dentalcrm.app.core.ui.components.ContentButton
import kz.dentalcrm.app.core.ui.components.SlotTable
import kz.dentalcrm.app.core.ui.rememberIntentOperations
import kz.dentalcrm.app.core.ui.utils.toColor
import kz.dentalcrm.app.core.utils.simplify
import kz.dentalcrm.app.data.network.response_model.employees.Employee
import kz.dentalcrm.app.navigation.AddAppointmentRoute
import kz.dentalcrm.app.navigation.AppNavigator
import kz.dentalcrm.app.navigation.EditAppointmentRoute
import kz.dentalcrm.app.navigation.ReplyByTemplateRoute
import kz.dentalcrm.app.screens.appointments.mvi.AppointmentViewEvent
import kz.dentalcrm.app.screens.appointments.mvi.AppointmentsViewSideEffect
import kz.dentalcrm.app.screens.appointments.mvi.models.UIAppointment
import kz.dentalcrm.app.screens.dialogs.PhoneActionDialog
import kz.dentalcrm.app.screens.ui.ContentHeader
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import kotlin.time.ExperimentalTime

@Composable
fun AppointmentsScreen() {
    val navigator: AppNavigator = koinInject()
    val viewModel: AppointmentsViewModel = koinViewModel()
    val viewState by viewModel.viewState.collectAsState()

    val lifecycleOwner: LifecycleOwner = LocalLifecycleOwner.current

    DisposableEffect(lifecycleOwner) {
        val observer = LifecycleEventObserver { _, event ->
            if (event == Lifecycle.Event.ON_RESUME) {
                viewModel.setEvent(AppointmentViewEvent.ReloadData)
            }
        }
        lifecycleOwner.lifecycle.addObserver(observer)
        onDispose {
            lifecycleOwner.lifecycle.removeObserver(observer)
        }
    }

    LaunchedEffect(viewModel.effect) {
        viewModel.effect.collect { effect ->
            when (effect) {
                is AppointmentsViewSideEffect.NavigateToEdit -> {
                    navigator.navigate(EditAppointmentRoute(effect.id))
                }
            }
        }
    }

    AppointmentsContent(
        selectedKey = viewState.selectedEmployee,
        selectedDate = viewState.selectedDate,
        event = viewModel::setEvent,
        loading = viewState.screenState is ScreenState.Loading,
        allAppointments = viewState.allAppointments,
        employees = viewState.employees,
        appointmentsByEmployee = viewState.appointmentsByEmployee
    ) { dateFrom, dateTo ->
        viewModel.setEvent(AppointmentViewEvent.LoadData(dateFrom = dateFrom, dateTo = dateTo))
    }
}

@OptIn(ExperimentalTime::class)
@Composable
fun AppointmentsContent(
    selectedKey: Employee?,
    selectedDate: LocalDate? = null,
    event: (AppointmentViewEvent) -> Unit,
    loading: Boolean = false,
    allAppointments: PersistentList<UIAppointment>,
    employees: PersistentList<Employee>,
    appointmentsByEmployee: PersistentMap<Employee, PersistentList<UIAppointment>>,
    getAppointments: (dateFrom: LocalDate, dateTo: LocalDate) -> Unit
) {
    val navigator: AppNavigator = koinInject()
    var isRefreshing by remember { mutableStateOf(false) }
    val pullToRefreshState = rememberPullToRefreshState(isRefreshing = isRefreshing)
    LaunchedEffect(loading) { if (!loading) isRefreshing = false }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .safeDrawingPadding()
    ) {
        Column(
            modifier = Modifier.align(Alignment.TopCenter)
        ) {
            Header(
                selectedDate = selectedDate,
            ) { dateFrom, dateTo ->
                getAppointments(dateFrom, dateTo)
            }
            HorizontalDivider(
                modifier = Modifier.fillMaxWidth(),
                thickness = 0.5.dp,
                color = MaterialTheme.colorScheme.secondaryContainer
            )
            PullToRefresh(
                state = pullToRefreshState,
                onRefresh = { isRefreshing = true; event(AppointmentViewEvent.ReloadData) },
                modifier = Modifier.fillMaxSize()
            ) {
                Body(
                    selectedKey = selectedKey,
                    event = event,
                    loading = loading,
                    allAppointments = allAppointments,
                    employees = employees,
                    appointmentsByEmployee = appointmentsByEmployee
                )
            }
        }
        FloatingActionButton(
            modifier = Modifier
                .navigationBarsPadding()
                .padding(
                    bottom = 96.dp,
                    start = 24.dp,
                    end = 24.dp,
                    top = 16.dp,
                )
                .align(Alignment.BottomEnd),
            shape = RoundedCornerShape(50),
            containerColor = DefaultTheme.colors.primary,
            contentColor = DefaultTheme.colors.onPrimary,
            onClick = {
                navigator.navigate(AddAppointmentRoute)
            }
        ) {
            Icon(
                imageVector = FeatherIcons.Plus,
                contentDescription = null
            )
        }
    }
}

@Composable
private fun Body(
    selectedKey: Employee?,
    event: (AppointmentViewEvent) -> Unit,
    loading: Boolean = false,
    allAppointments: PersistentList<UIAppointment>,
    employees: PersistentList<Employee>,
    appointmentsByEmployee: PersistentMap<Employee, PersistentList<UIAppointment>>
) {
    val navigator: AppNavigator = koinInject()
    val shimmer = rememberShimmer(ShimmerBounds.Window)
    val intentOperations = rememberIntentOperations()
    var selectedPhone by remember { mutableStateOf<String?>(null) }

    val scope = rememberCoroutineScope()
    val noComposition by rememberLottieComposition {
        LottieCompositionSpec.JsonString(
            Res.readBytes("files/no_history.json").decodeToString()
        )
    }

    selectedPhone?.let { selectedPhoneValue ->
        val whatsAppMessage = "Здравствуйте, уважаемый пациент!"
        PhoneActionDialog(
            phone = selectedPhoneValue,
            onDismissRequest = { selectedPhone = null },
            onCall = { phone ->
                if (phone.length < 11) {
                    intentOperations.openPhoneDialer(
                        phoneNumber = "+7${phone}"
                    )
                } else {
                    intentOperations.openPhoneDialer(
                        phoneNumber = "+${phone}"
                    )
                }
            },
            onWhatsapp = { phone ->
                if (phone.length < 11) {
                    intentOperations.openWhatsApp(
                        phoneNumber = "7+${phone}",
                        appendedText = whatsAppMessage
                    )
                } else {
                    intentOperations.openWhatsApp(
                        phoneNumber = "+${phone}",
                        appendedText = whatsAppMessage
                    )
                }
            },
            onSend = {
                selectedPhone = null
                val formattedPhone =
                    if (selectedPhoneValue.length < 11) "7$selectedPhoneValue" else selectedPhoneValue
                navigator.navigate(ReplyByTemplateRoute(phone = formattedPhone))
            }
        )
    }

    var selectedAppointmentForStatus by remember {
        mutableStateOf<UIAppointment?>(null)
    }

    selectedAppointmentForStatus?.let { appointment ->
        AppointmentStatusDialog(
            status = appointment.data.status ?: "pending",
            onDismiss = { selectedAppointmentForStatus = null },
            onStatusChanged = { status ->
                event(
                    AppointmentViewEvent.OnStatusChanged(
                        appointmentId = appointment.data.id,
                        status = status
                    )
                )
            }
        )
    }

    if (loading && appointmentsByEmployee.isEmpty()) {
        LazyColumn(
            contentPadding = PaddingValues(top = 8.dp, bottom = 120.dp)
        ) {
            items(8) { AppointmentItemSkeleton(shimmer = shimmer) }
        }
    } else if (appointmentsByEmployee.isEmpty()) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Image(
                modifier = Modifier.size(120.dp),
                painter = rememberLottiePainter(
                    composition = noComposition,
                    iterations = 1
                ),
                contentDescription = "Lottie animation"
            )
            Spacer(modifier = Modifier.height(16.dp))
            Text(
                text = stringResource(Res.string.error_no_records),
                style = DefaultTheme.typography.bodyMediumRegular,
                color = DefaultTheme.colors.onSurface,
            )
            Spacer(
                modifier = Modifier.size(120.dp),
            )
        }
    } else {

        val contentModifier = if (loading) {
            Modifier.fillMaxSize().shimmerModifier(shimmer)
        } else {
            Modifier.fillMaxSize()
        }

        BoxWithConstraints(modifier = contentModifier) {
            val isExpandedScreen = maxWidth >= WIDTH_DP_MEDIUM_LOWER_BOUND.dp

        if (isExpandedScreen) {
            Column(modifier = Modifier.fillMaxSize()) {
                SlotTable(
                    items = appointmentsByEmployee,
                    modifier = Modifier.fillMaxWidth(),
                    headerHeight = 32.dp,
                    contentPadding = PaddingValues(top = 16.dp, start = 16.dp, end = 16.dp),
                    indicationShape = RoundedCornerShape(topEnd = 16.dp, topStart = 16.dp),
                    selectionColor = DefaultTheme.colors.surfaceAlternative.copy(alpha = 0.3f),
                    selectedKey = selectedKey,
                    headerContent = { key, isSelected ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(32.dp)
                                .background(
                                    color =
                                        if (isSelected) {
                                            DefaultTheme.colors.primary
                                        } else {
                                            DefaultTheme.colors.surface
                                        },
                                    shape = RoundedCornerShape(16.dp)
                                )
                                .clip(
                                    shape = RoundedCornerShape(16.dp)
                                )
                                .clickable {
                                    event(AppointmentViewEvent.SelectEmployee(key))
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = key.simplify(),
                                style = DefaultTheme.typography.bodyMediumMedium,
                                color = if (isSelected) DefaultTheme.colors.onPrimary else DefaultTheme.colors.onSurface
                            )
                        }
                    },
                    itemContent = { item, isSelected ->
                        Box(modifier = Modifier.padding(horizontal = 16.dp)) {
                            AppointmentsItem(
                                modifier = Modifier,
                                item = item,
                                onItemClicked = {
                                    //scope.launch { listState.animateScrollToItem(index) }
                                },
                                onEditClicked = {
                                    event(AppointmentViewEvent.Edit(item.data.id))
                                },
                                onPhoneClicked = {
                                    selectedPhone = item.data.patient?.phone
                                },
                                onStatusClicked = {
                                    selectedAppointmentForStatus = item
                                },
                                onDeleteClicked = {
                                    event(AppointmentViewEvent.Delete(item.data.id))
                                }
                            )
                        }
                    }
                )
            }
        } else {
            val pagerState = rememberPagerState(pageCount = { employees.size + 1 })

            Column(modifier = Modifier.fillMaxSize()) {
                @OptIn(androidx.compose.material3.ExperimentalMaterial3Api::class)
                androidx.compose.runtime.CompositionLocalProvider(
                    androidx.compose.material3.LocalRippleConfiguration provides null
                ) {
                    PrimaryScrollableTabRow(
                        selectedTabIndex = pagerState.currentPage,
                        modifier = Modifier.fillMaxWidth(),
                        edgePadding = 16.dp,
                        containerColor = Color.Transparent,
                        indicator = {
                            Box(
                                Modifier
                                    .zIndex(-1f)
                                    .tabIndicatorOffset(pagerState.currentPage)
                                    .fillMaxSize(),
                                contentAlignment = Alignment.Center
                            ) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(32.dp)
                                        .background(
                                            color = DefaultTheme.colors.primary,
                                            shape = RoundedCornerShape(12.dp)
                                        )
                                )
                            }
                        },
                        divider = { }
                    ) {
                        Tab(
                            selected = pagerState.currentPage == 0,
                            onClick = {
                                scope.launch {
                                    pagerState.animateScrollToPage(0)
                                }
                            },
                            text = {
                                Text(
                                    text = stringResource(Res.string.tab_all),
                                    style = DefaultTheme.typography.bodyMediumMedium,
                                    color = if (pagerState.currentPage == 0) DefaultTheme.colors.onPrimary else DefaultTheme.colors.onSurface
                                )
                            }
                        )
                        employees.forEachIndexed { index, employee ->
                            val actualIndex = index + 1
                            Tab(
                                selected = pagerState.currentPage == actualIndex,
                                onClick = {
                                    scope.launch {
                                        pagerState.animateScrollToPage(actualIndex)
                                    }
                                },
                                text = {
                                    Text(
                                        text = employee.simplify(),
                                        style = DefaultTheme.typography.bodyMediumMedium,
                                        color = if (pagerState.currentPage == actualIndex) DefaultTheme.colors.onPrimary else DefaultTheme.colors.onSurface
                                    )
                                }
                            )
                        }
                    }
                }

                HorizontalPager(
                    state = pagerState,
                    modifier = Modifier.fillMaxWidth().weight(1f)
                ) { page ->
                    val employeeAppointments = if (page == 0) {
                        allAppointments
                    } else {
                        val employee = employees[page - 1]
                        appointmentsByEmployee[employee]
                            ?: kotlinx.collections.immutable.persistentListOf()
                    }
                    val listState = rememberLazyListState()

                    LazyColumn(
                        modifier = Modifier.fillMaxSize().animateContentSize(),
                        contentPadding = PaddingValues(top = 8.dp, bottom = 120.dp),
                        state = listState
                    ) {
                        itemsIndexed(
                            items = employeeAppointments,
                            key = { index, appointment -> appointment.data.id }
                        ) { index, item ->
                            Box(modifier = Modifier.padding(horizontal = 16.dp).animateItem()) {
                                AppointmentsItem(
                                    modifier = Modifier.animateItem(),
                                    item = item,
                                    onItemClicked = {
                                        scope.launch { listState.animateScrollToItem(index) }
                                    },
                                    onEditClicked = {
                                        event(AppointmentViewEvent.Edit(item.data.id))
                                    },
                                    onPhoneClicked = {
                                        selectedPhone = item.data.patient?.phone
                                    },
                                    onStatusClicked = {
                                        selectedAppointmentForStatus = item
                                    },
                                    onDeleteClicked = {
                                        event(AppointmentViewEvent.Delete(item.data.id))
                                    }
                                )
                            }
                        }
                    }
                }
            }
        }
        } // BoxWithConstraints
    }
}

@OptIn(ExperimentalTime::class)
@Composable
private fun Header(
    selectedDate: LocalDate? = null,
    selectedDates: (LocalDate, LocalDate) -> Unit,
) {
    val windowSizeClass = currentWindowAdaptiveInfo().windowSizeClass
    val isExpandedScreen = windowSizeClass.isWidthAtLeastBreakpoint(WIDTH_DP_MEDIUM_LOWER_BOUND)
    val fullExpanded = windowSizeClass.isWidthAtLeastBreakpoint(WIDTH_DP_LARGE_LOWER_BOUND)

    val floatDiff = when {
        isExpandedScreen -> 14f
        fullExpanded -> 21f
        else -> 7f
    }

    val formatter = stringResource(Res.string.appointments_formatter)
    val currentDate = rememberSaveable { LocalDate.now() }
    val startDate = rememberSaveable { currentDate.minusDays(45) }
    val endDate = rememberSaveable { currentDate.plusDays(120) }
    val effectiveDate = selectedDate ?: currentDate

    ContentHeader(
        text = "$formatter ${
            if (effectiveDate.day == LocalDate.now().day) {
                stringResource(Res.string.today)
            } else {
                effectiveDate.month.ordinal.getMonth()
            }
        }",
        textModifier = Modifier.padding(start = 16.dp, top = 8.dp, end = 16.dp),
        modifier = Modifier
            .fillMaxWidth(),
    ) {
        BoxWithConstraints(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            val state = rememberWeekCalendarState(
                startDate = startDate,
                endDate = endDate,
                firstVisibleWeekDate = effectiveDate,
            )
            WeekCalendar(
                modifier = Modifier.padding(vertical = 4.dp),
                contentPadding = PaddingValues(all = 4.dp),
                state = state,
                calendarScrollPaged = isExpandedScreen.not(),
                dayContent = { day ->
                    Day(
                        modifier = Modifier.width(this@BoxWithConstraints.maxWidth / floatDiff),
                        date = day.date,
                        selected = effectiveDate == day.date,
                    ) {
                        selectedDates(it, it)
                    }
                },
            )
        }
    }
}

@Composable
private fun AppointmentsItem(
    modifier: Modifier,
    item: UIAppointment,
    onItemClicked: () -> Unit,
    onEditClicked: () -> Unit,
    onPhoneClicked: () -> Unit,
    onStatusClicked: () -> Unit,
    onDeleteClicked: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp)
            .heightIn()
            .background(
                color = when (item.data.status) {
                    "pending" -> DefaultTheme.colors.surfaceAlternative
                    "success" -> DefaultTheme.colors.success.copy(
                        alpha = 0.3f
                    )

                    else -> DefaultTheme.colors.error.copy(
                        alpha = 0.5f
                    )
                },
                shape = RoundedCornerShape(16.dp)
            )
            .animateContentSize()
            .then(modifier),
    ) {
        var expanded by rememberSaveable { mutableStateOf(false) }
        item.data.comment?.let {
            Spacer(modifier = Modifier.height(8.dp))
            Text(
                modifier = Modifier.fillMaxWidth()
                    .padding(horizontal = 12.dp),
                text = stringResource(Res.string.comment_append),
                style = DefaultTheme.typography.labelRegular,
                color = DefaultTheme.colors.onSurface
            )
            Text(
                text = it,
                modifier = Modifier.fillMaxWidth()
                    .padding(horizontal = 12.dp),
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
                style = DefaultTheme.typography.bodyMediumMedium,
                color = DefaultTheme.colors.onSurface
            )
            Spacer(modifier = Modifier.height(8.dp))
        }
        Row(
            modifier = Modifier
                .clickable(
                    indication = null,
                    interactionSource = remember { MutableInteractionSource() }) {
                    expanded = !expanded
                    onItemClicked()
                },
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Spacer(
                modifier = Modifier
                    .width(8.dp)
            )
            Box(
                modifier = Modifier
                    .width(4.dp)
                    .background(
                        color = runCatching {
                            item.data.employee?.color?.toColor()
                        }.getOrNull() ?: Color(0xFF6D5DD3),
                        shape = RoundedCornerShape(12.dp)
                    )
                    .height(72.dp)
                    .padding(
                        vertical = 8.dp
                    )
            )
            Spacer(
                modifier = Modifier
                    .width(8.dp)
            )
            Column(
                modifier = Modifier.weight(1f)
            ) {
                Spacer(modifier = Modifier.height(12.dp))
                Text(
                    text = stringResource(Res.string.patient_formatter),
                    style = DefaultTheme.typography.labelRegular,
                    color = DefaultTheme.colors.onSurface
                )
                Text(
                    text = "${item.data.patient?.surname} ${item.data.patient?.name}",
                    style = DefaultTheme.typography.bodyMediumMedium,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    text = stringResource(Res.string.doctor_formatter),
                    style = DefaultTheme.typography.labelRegular,
                    color = DefaultTheme.colors.onSurface
                )
                Text(
                    text = "${item.data.employee?.surname} ${item.data.employee?.name}",
                    style = DefaultTheme.typography.bodyMediumMedium,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(12.dp))
            }
            Column(
                modifier = Modifier,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(modifier = Modifier.height(12.dp))
                Text(
                    text = stringResource(Res.string.appointment_time),
                    style = DefaultTheme.typography.labelMedium,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(4.dp))
                Text(
                    text = item.time,
                    style = DefaultTheme.typography.heading1,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(12.dp))
            }
            Spacer(modifier = Modifier.width(8.dp))
        }
        AnimatedVisibility(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight(),
            visible = expanded,
            enter = slideInVertically { it } + fadeIn(),
            exit = slideOutVertically { it } + fadeOut()
        ) {
            Column {
                Spacer(modifier = Modifier.height(8.dp))
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .padding(horizontal = 8.dp),
                    horizontalArrangement = Arrangement.SpaceEvenly,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    AppointmentActionItem(
                        modifier = Modifier.weight(1f),
                        title = stringResource(Res.string.connect),
                        icon = FeatherIcons.Phone,
                        containerColor = DefaultTheme.colors.primary,
                        contentColor = DefaultTheme.colors.onPrimary,
                        onClick = onPhoneClicked
                    )
                    Spacer(modifier = Modifier.width(4.dp))
                    AppointmentActionItem(
                        modifier = Modifier.weight(1f),
                        title = when (item.data.status) {
                            "pending" -> stringResource(Res.string.pending_short)
                            "success" -> stringResource(Res.string.visited_short)
                            else -> stringResource(Res.string.not_visited_short)
                        },
                        containerColor = DefaultTheme.colors.primary,
                        contentColor = DefaultTheme.colors.onPrimary,
                        icon = when (item.data.status) {
                            "pending" -> FeatherIcons.Circle
                            "success" -> FeatherIcons.CheckCircle
                            else -> FeatherIcons.XCircle
                        },
                        onClick = onStatusClicked
                    )
                    Spacer(modifier = Modifier.width(4.dp))
                    AppointmentActionItem(
                        modifier = Modifier.weight(1f),
                        title = stringResource(Res.string.details),
                        icon = FeatherIcons.Edit,
                        containerColor = DefaultTheme.colors.primary,
                        contentColor = DefaultTheme.colors.onPrimary,
                        onClick = onEditClicked
                    )
                    Spacer(modifier = Modifier.width(4.dp))
                    AppointmentActionItem(
                        modifier = Modifier.weight(1f),
                        title = stringResource(Res.string.delete),
                        icon = FeatherIcons.Trash,
                        containerColor = DefaultTheme.colors.error,
                        contentColor = DefaultTheme.colors.onPrimary,
                        onClick = onDeleteClicked
                    )
                }
                Spacer(modifier = Modifier.height(8.dp))
            }
        }
    }
}

@Composable
private fun AppointmentActionItem(
    modifier: Modifier,
    title: String = "",
    containerColor: Color,
    contentColor: Color,
    icon: ImageVector,
    onClick: () -> Unit
) {
    Column(
        modifier = Modifier.height(56.dp)
            .then(modifier),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        ContentButton(
            modifier = Modifier.fillMaxWidth()
                .background(
                    color = containerColor,
                    shape = RoundedCornerShape(8.dp)
                ),
            shape = RoundedCornerShape(8.dp),
            onClick = onClick,
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Spacer(modifier = Modifier.height(8.dp))
                Icon(
                    modifier = Modifier.size(16.dp),
                    imageVector = icon,
                    contentDescription = title,
                    tint = contentColor
                )
                Spacer(modifier = Modifier.height(8.dp))
                Text(
                    text = title,
                    style = DefaultTheme.typography.labelRegular,
                    textAlign = TextAlign.Center,
                    overflow = TextOverflow.Ellipsis,
                    color = contentColor
                )
                Spacer(modifier = Modifier.height(8.dp))
            }
        }

    }
}


@OptIn(ExperimentalTime::class)
@Composable
private fun Day(
    date: LocalDate,
    selected: Boolean = false,
    modifier: Modifier = Modifier,
    onClick: (LocalDate) -> Unit = { },
) {
    Box(
        modifier = modifier
            .padding(4.dp)
            .clip(RoundedCornerShape(8.dp))
            .background(
                color = if (selected) {
                    DefaultTheme.colors.primary
                } else {
                    Color.Transparent
                }
            )
            .fillMaxWidth()
            .wrapContentHeight()
            .clickable { onClick(date) },
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier.padding(vertical = 10.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            Text(
                text = date.dayOfWeek.ordinal.getWeekDay(),
                color = if (selected)
                    DefaultTheme.colors.onPrimary
                else
                    DefaultTheme.colors.onSurface,
                style = DefaultTheme.typography.labelRegular
            )
            Spacer(modifier = Modifier.height(2.dp))
            Text(
                text = dateFormatter.format(date),
                color = if (selected)
                    DefaultTheme.colors.onPrimary
                else
                    DefaultTheme.colors.onSurface,
                style = DefaultTheme.typography.bodyMediumMedium
            )
        }
    }
}

@Composable
fun Int.getWeekDay(): String {
    return when (this@getWeekDay) {
        0 -> stringResource(Res.string.week_day_one_short)
        1 -> stringResource(Res.string.week_day_two_short)
        2 -> stringResource(Res.string.week_day_three_short)
        3 -> stringResource(Res.string.week_day_four_short)
        4 -> stringResource(Res.string.week_day_five_short)
        5 -> stringResource(Res.string.week_day_six_short)
        6 -> stringResource(Res.string.week_day_seven_short)
        else -> ""
    }
}

@Composable
fun Int.getMonth(): String {
    return when (this@getMonth) {
        0 -> stringResource(Res.string.month_one)
        1 -> stringResource(Res.string.month_two)
        2 -> stringResource(Res.string.month_three)
        3 -> stringResource(Res.string.month_four)
        4 -> stringResource(Res.string.month_five)
        5 -> stringResource(Res.string.month_six)
        6 -> stringResource(Res.string.month_seven)
        7 -> stringResource(Res.string.month_eight)
        8 -> stringResource(Res.string.month_nine)
        9 -> stringResource(Res.string.month_ten)
        10 -> stringResource(Res.string.month_eleven)
        11 -> stringResource(Res.string.month_twelve)
        else -> ""
    }
}


@Composable
private fun AppointmentItemSkeleton(shimmer: kz.dentalcrm.app.theme.shimmer.Shimmer) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 4.dp)
            .background(
                color = DefaultTheme.colors.surfaceAlternative,
                shape = RoundedCornerShape(16.dp)
            )
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Spacer(modifier = Modifier.width(8.dp))
            Box(
                modifier = Modifier
                    .width(4.dp)
                    .height(72.dp)
                    .shimmerModifier(shimmer)
                    .background(
                        color = DefaultTheme.colors.onSurface.copy(alpha = 0.12f),
                        shape = RoundedCornerShape(12.dp)
                    )
            )
            Spacer(modifier = Modifier.width(8.dp))
            Column(modifier = Modifier.weight(1f)) {
                Spacer(modifier = Modifier.height(12.dp))
                Box(
                    modifier = Modifier
                        .fillMaxWidth(0.3f)
                        .height(12.dp)
                        .shimmerModifier(shimmer)
                        .background(
                            color = DefaultTheme.colors.onSurface.copy(alpha = 0.12f),
                            shape = RoundedCornerShape(4.dp)
                        )
                )
                Spacer(modifier = Modifier.height(4.dp))
                Box(
                    modifier = Modifier
                        .fillMaxWidth(0.6f)
                        .height(14.dp)
                        .shimmerModifier(shimmer)
                        .background(
                            color = DefaultTheme.colors.onSurface.copy(alpha = 0.12f),
                            shape = RoundedCornerShape(4.dp)
                        )
                )
                Spacer(modifier = Modifier.height(4.dp))
                Box(
                    modifier = Modifier
                        .fillMaxWidth(0.25f)
                        .height(12.dp)
                        .shimmerModifier(shimmer)
                        .background(
                            color = DefaultTheme.colors.onSurface.copy(alpha = 0.12f),
                            shape = RoundedCornerShape(4.dp)
                        )
                )
                Spacer(modifier = Modifier.height(4.dp))
                Box(
                    modifier = Modifier
                        .fillMaxWidth(0.5f)
                        .height(14.dp)
                        .shimmerModifier(shimmer)
                        .background(
                            color = DefaultTheme.colors.onSurface.copy(alpha = 0.12f),
                            shape = RoundedCornerShape(4.dp)
                        )
                )
                Spacer(modifier = Modifier.height(12.dp))
            }
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Spacer(modifier = Modifier.height(12.dp))
                Box(
                    modifier = Modifier
                        .size(40.dp)
                        .shimmerModifier(shimmer)
                        .background(
                            color = DefaultTheme.colors.onSurface.copy(alpha = 0.12f),
                            shape = RoundedCornerShape(8.dp)
                        )
                )
                Spacer(modifier = Modifier.height(12.dp))
            }
            Spacer(modifier = Modifier.width(8.dp))
        }
    }
    Spacer(modifier = Modifier.height(4.dp))
}

private val dateFormatter by lazy {
    LocalDate.Format {
        day(padding = Padding.ZERO)
    }
}
